// extracted by mini-css-extract-plugin
export default {"list":"header-nav-module--list--1b9d7","item":"header-nav-module--item--86add","link":"header-nav-module--link--ab707","active":"header-nav-module--active--7f1a9"};